import { render, staticRenderFns } from "./BadgeIcon.vue?vue&type=template&id=a5ca9674&scoped=true"
import script from "./BadgeIcon.vue?vue&type=script&lang=js"
export * from "./BadgeIcon.vue?vue&type=script&lang=js"
import style0 from "./BadgeIcon.vue?vue&type=style&index=0&id=a5ca9674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ca9674",
  null
  
)

export default component.exports